import UserPasswordChangeRequest from "../../../api/raily/user/password-change/user-password-change-request";
import UserPasswordChangeParams from "./user-password-change-params";

const createRequest = (
  params: UserPasswordChangeParams,
): UserPasswordChangeRequest => {
  return {
    newPassword: params.newPassword,
    oldPassword: params.oldPassword,
  };
};

const userPasswordChangeParamsFactory = {
  createRequest,
};

export default userPasswordChangeParamsFactory;
